import classNames from "classnames";

type AvatarVariant = "circle" | "rounded" | "standard";

interface AvatarPreviewCardProps {
  imageUrl: string;
  variant: AvatarVariant;
  className?: string;
}

const variantConfig: Record<AvatarVariant, { title: string; subtitle: string; className: string }> = {
  circle: {
    title: "Circle",
    subtitle: "Avatar",
    className: "rounded-full"
  },
  rounded: {
    title: "Rounded",
    subtitle: "Square",
    className: "rounded-xl"
  },
  standard: {
    title: "Standard",
    subtitle: "4:5 Ratio",
    className: "rounded-md"
  }
};

export default function AvatarPreviewCard({ imageUrl, variant, className = "" }: AvatarPreviewCardProps) {
  const config = variantConfig[variant];

  return (
    <div
      className={classNames("flex flex-col items-center flex-shrink-0", className)}
      data-testid={`avatar-preview-${variant}`}
    >
      <div
        className={classNames("w-[100px] h-[100px] overflow-hidden bg-sys-brand-surface-container", config.className)}
      >
        <img src={imageUrl} alt={`${config.title} preview`} className="w-full h-full object-cover" />
      </div>
      <p className="text-body-medium font-semibold text-sys-brand-on-surface mt-2">{config.title}</p>
      <p className="text-body-small text-sys-brand-on-surface-variant">{config.subtitle}</p>
    </div>
  );
}
